import { render, staticRenderFns } from "./TabThree.vue?vue&type=template&id=a0e232ae&"
import script from "./TabThree.vue?vue&type=script&lang=js&"
export * from "./TabThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports